
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';
import D1 from '../../components/ExcerciseTypes/Design/TypeIn';



const json = {
  1: { // Exercise num
    unit: 'Unit 8',
    id: 'WB3-U8-P56-E1',
    audio: 'img/FriendsPlus/Page56/Audio/audio-e1-p56.mp3',
    video: '',
    component: DesignUnderLine,
    totalInput: 3,
    exerciseKey: 'img/FriendsPlus/Page56/E1/Key/answerKey.png',
    titleImage: '',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page56/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page56/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page56/Audio/tieude-e1-p56.mp3' },
        { url: 'img/FriendsPlus/Page56/E1/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page56/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page56/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page56/E1/6.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page56/E1/7.jpg' },
        { url: 'img/FriendsPlus/Page56/E1/8.jpg', input: 1, },
        { url: 'img/FriendsPlus/Page56/E1/9.jpg' },
        { url: 'img/FriendsPlus/Page56/E1/10.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page56/E1/11.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page56/E1/12.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page56/E1/13.jpg' },
        { url: 'img/FriendsPlus/Page56/E1/14.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page56/E1/15.jpg' },
        { url: 'img/FriendsPlus/Page56/E1/16.jpg', input: 2, },
        { url: 'img/FriendsPlus/Page56/E1/17.jpg' },
        { url: 'img/FriendsPlus/Page56/E1/18.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page56/E1/19.jpg' },
        { url: 'img/FriendsPlus/Page56/E1/20.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page56/E1/21.jpg' },
        { url: 'img/FriendsPlus/Page56/E1/22.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page56/E1/23.jpg' },
        { url: 'img/FriendsPlus/Page56/E1/24.jpg', input: 3, },
        { url: 'img/FriendsPlus/Page56/E1/25.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page56/E1/26.jpg' },
      ],
    ]
  },
  2: { // Exercise num
    unit: 'Unit 8',
    id: 'WB3-U8-P56-E2',
    audio: '',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page56/E2/Key/answerKey.png',
    component: D1,
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page56/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page56/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page56/E2/3.jpg', input: true, answer: "fly a kite" },
        { url: 'img/FriendsPlus/Page56/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page56/E2/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page56/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page56/E2/7.jpg', input: true, answer: "snowing" },
        { url: 'img/FriendsPlus/Page56/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page56/E2/9.jpg', input: true, answer: "make a snowman" },
        { url: 'img/FriendsPlus/Page56/E2/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page56/E2/11.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page56/E2/12.jpg' },
        { url: 'img/FriendsPlus/Page56/E2/13.jpg', input: true, answer: "sunny" },
        { url: 'img/FriendsPlus/Page56/E2/14.jpg' },
        { url: 'img/FriendsPlus/Page56/E2/15.jpg', input: true, answer: "play outside" },
        { url: 'img/FriendsPlus/Page56/E2/16.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page56/E2/17.jpg' },
      ],

    ]
  },
}
export default json;